export const versions = {
  version: "1.0.183",
  revision: "3a63c16a8",
  branch: "HEAD",
  gitInfo: {
    dirty: true,
    raw: "v1.0.183-5116-g3a63c16a8-dirty",
    hash: "g3a63c16a8",
    distance: 5116,
    tag: "v1.0.183",
    semver: {
      options: { loose: false, includePrerelease: false },
      loose: false,
      raw: "v1.0.183",
      major: 1,
      minor: 0,
      patch: 183,
      prerelease: [],
      build: [],
      version: "1.0.183"
    },
    suffix: "5116-g3a63c16a8-dirty",
    semverString: "1.0.183+5116.g3a63c16a8.dirty"
  }
};
